/*
 * � 2020 Microsoft. All rights reserved.
 */

define('SolitaireShared/TriPeaksLogic/IDailyTripeaksAuthority',[
    'SolitaireShared/TriPeaksLogic/TriPeaksAuthority',
    'SolitaireShared/CardLogic/IDailyAuthority',
    'SolitaireShared/CardLogic/CardOp',
    'SolitaireShared/CardLogic/MoveState'
], function (TriPeaksAuthority, IDailyAuthority, CardOp, MoveState) {
    "use strict";

    var IDailyTriPeaksAuthority = function () {
        this.initIDailyTriPeaksAuthority();
    };

    IDailyTriPeaksAuthority.TAG_MOVEPERFORMED = 0x40000000;

    IDailyTriPeaksAuthority.constructor = IDailyTriPeaksAuthority;
    IDailyTriPeaksAuthority.prototype = Object.create(TriPeaksAuthority.prototype);
    IDailyAuthority.call(IDailyTriPeaksAuthority.prototype);

    IDailyTriPeaksAuthority.prototype.initIDailyTriPeaksAuthority = function () {
        TriPeaksAuthority.call(this);

        this.MovesAllowed = 0;

        this._startingTime = 0;

        this.ChallengeType = IDailyAuthority.ChallengeType.Unknown;

        this.DeckSeeds = [];

        this.IsChallenge = true;

        this.TotalMoves = 0;

        this.MaxDeals = TriPeaksAuthority.MAX_DEALS;
    };

    Object.defineProperty(IDailyTriPeaksAuthority.prototype, "TimerEnabled", {
        get: function () {
            return this._startingTime != 0;
        }
    });

    Object.defineProperty(IDailyTriPeaksAuthority.prototype, "StartingTime", {
        get: function () {
            return this._startingTime;
        },
        set: function (value) {
            this._startingTime = value;
            this.CardSupply.IsTimerCountdown = this._startingTime != 0;
        }
    });

    IDailyTriPeaksAuthority.prototype.GetScoreForAction = function (action) {
        for (var i = 0; i < action.Ops.length; i++) {
            var op = action.Ops[i];
            if (this.MovesAllowed > 0 && action.GetActionUndoCount() == 0 && op.Opcode != CardOp.Op.Noop && op.Opcode != CardOp.Op.Deal) {
                action.Tag = (action.Tag | IDailyTriPeaksAuthority.TAG_MOVEPERFORMED) >>> 0;
            }
        }

        return TriPeaksAuthority.prototype.GetScoreForAction.call(this, action);
    };


    IDailyTriPeaksAuthority.prototype.OnRunSpecialAction = function (tag, undo) {
        if (this.MovesAllowed > 0)
            this.TotalMoves += (undo ? -1 : 1);

        TriPeaksAuthority.prototype.OnRunSpecialAction.call(this, tag, undo);
    };


    IDailyTriPeaksAuthority.prototype.IsGameWon = function () {
        if (this.MovesAllowed > 0)
            return (TriPeaksAuthority.prototype.IsGameWon.call(this) && this.TotalMoves <= this.MovesAllowed + 1);
        else
            return TriPeaksAuthority.prototype.IsGameWon.call(this);
    };

    IDailyTriPeaksAuthority.prototype.CurrentMoveState = function () {
        if (this.MovesAllowed > 0) {
            if (this.TotalMoves > this.MovesAllowed + 1) {
                return MoveState.NoMovesLeft;
            }
            if (this.TotalMoves == this.MovesAllowed + 1) {
                if (this.IsGameWon()) {
                    return MoveState.CanMove;
                }
                return MoveState.NoMovesLeft;
            }
        }
        return TriPeaksAuthority.prototype.CurrentMoveState.call(this);
    };
    //#if !CHEATS
    IDailyTriPeaksAuthority.prototype.GetHint = function (cycle, cheat) {
        cycle = !!cycle;
        if(!cheat) {
            return new CardOp(this.CardSupply);
        } else {
            return TriPeaksAuthority.prototype.GetHint.call(this, cycle, cheat);
        }
    };

    //#endif

    IDailyTriPeaksAuthority.prototype.SetDealScript = function (script) {
        this.DealScript = script;
    };

    IDailyTriPeaksAuthority.prototype.SetNumBoardsCompleted = function (numBoards) {
        this.NumBoardsCompleted = numBoards;
    };


    IDailyTriPeaksAuthority.prototype.GetIthDeckSeed = function (i) {
        if (!this.CardSupply.IsGamePageLoaded) {
            return TriPeaksAuthority.prototype.GetIthDeckSeed.call(this, i);
        }
        if (this.DeckSeeds.length > i)
            return this.DeckSeeds[i];
        return null;
    };

    IDailyTriPeaksAuthority.prototype.Deal = function () {
        if (!this.CardSupply.IsGamePageLoaded) {
            return TriPeaksAuthority.prototype.Deal.call(this);
        }
        this.TotalMoves = 0;

        if (this.DeckSeeds.length > 0)
            this.CardSupply.DeckSeed = this.DeckSeeds[0];

        return TriPeaksAuthority.prototype.Deal.call(this);
    };

    IDailyTriPeaksAuthority.prototype.GetStartingTime = function () {
        return this.StartingTime;
    };

    return IDailyTriPeaksAuthority;


});
